import { render, staticRenderFns } from "./AuthOrgDialog.vue?vue&type=template&id=68851de8"
import script from "./AuthOrgDialog.vue?vue&type=script&lang=js"
export * from "./AuthOrgDialog.vue?vue&type=script&lang=js"
import style0 from "./AuthOrgDialog.vue?vue&type=style&index=0&id=68851de8&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68851de8')) {
      api.createRecord('68851de8', component.options)
    } else {
      api.reload('68851de8', component.options)
    }
    module.hot.accept("./AuthOrgDialog.vue?vue&type=template&id=68851de8", function () {
      api.rerender('68851de8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/auth/org/components/org/AuthOrgDialog.vue"
export default component.exports